'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _sellerRecordResults = require('./remote/sellerRecordResults');

var SellerRecordResults = {
    fetchSellerRecordResultsById: function fetchSellerRecordResultsById(params) {
        return _sellerRecordResults.SellerRecordResultsRemote.fetchSellerRecordResultsById(params);
    }
};

exports.default = SellerRecordResults;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/sellerRecordResults.js
// module id = iZFz
// module chunks = 46